import React, { useEffect } from 'react';
import './SuccessModal.css';

const SuccessModal = ({ show, message, onClose }) => {
  useEffect(() => {
    if (show) {
      const timer = setTimeout(() => {
        onClose();
      }, 1000);
      return () => clearTimeout(timer);
    }
  }, [show, onClose]);

  if (!show) return null;

  return (
    <div className="success-modal-overlay" onClick={onClose}>
      <div className="success-modal" onClick={(e) => e.stopPropagation()}>
        <div className="success-modal-icon">
          <i className="fas fa-check-circle"></i>
        </div>
        <div className="success-modal-content">
          <h3 className="success-modal-title">تمت العملية بنجاح</h3>
          <p className="success-modal-subtitle">Operation completed successfully</p>
          {message && <p className="success-modal-message">{message}</p>}
        </div>
        <button className="success-modal-close" onClick={onClose}>
          <i className="fas fa-times"></i>
        </button>
      </div>
    </div>
  );
};

export default SuccessModal;

